// removed by extract-text-webpack-plugin
module.exports = {"modal-header":"app-pages-Ingredient-Recipes-RecipesDetail-RecipesForm-ConfirmSubmitModal-__ConfirmSubmitModal___2l8aX","modal-dialog":"app-pages-Ingredient-Recipes-RecipesDetail-RecipesForm-ConfirmSubmitModal-__ConfirmSubmitModal___2VP7U"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Ingredient/Recipes/RecipesDetail/RecipesForm/ConfirmSubmitModal/ConfirmSubmitModal.css
// module id = 2368
// module chunks = 0